<template>
  <div class="projectData">
    <el-form :model="queryInfo" class="ly-header__bg" label-width="100px">
      <el-form-item label="所属行业：">
        <SelectTreeRadio
          apiName="getIndustryThree"
          resultType="values"
          storageKey="industryCategory"
          v-model="queryInfo.industryCategory"
          @input="(e) => labelTagChange('industryCategory', e, '所属行业')"
        ></SelectTreeRadio>
      </el-form-item>
    </el-form>
    <div class="ly-container__bg">
      <div class="ly_operation">
        <div class="left">
          <ImportFilePopup
            moduleName="智参企业"
            templateUrl="/template/智参企业上传.xlsx"
            buttonText="批量上传企业"
            popupTitle="批量新增智参企业"
            templateName="智参企业"
            @uploadSuccess="search"
          />

          <el-button @click="multiDelete">
            批量删除
            <i class="jr-iconjr-icon-delect" />
          </el-button>

          <el-button @click="multiDelete">
            批量导出
            <i class="jr-iconjr-icon-export" />
          </el-button>

          <popover @popoverClick="popoverClick" />

          <div class="upload_time">
            <div class="caretTime" @click="uploadTime" style="color: #606266">
              按创建时间
            </div>
            <i
              class="el-icon-caret-top"
              :class="[
                queryInfo.columnName == 'create_time' && queryInfo.order == 0
                  ? 'isActiveTime1'
                  : 'iconColor',
              ]"
            />
            <i
              class="el-icon-caret-bottom"
              :class="[
                queryInfo.columnName == 'create_time' && queryInfo.order == 1
                  ? 'isActiveTime1'
                  : 'iconColor',
              ]"
            />
          </div>
        </div>

        <MySearchInput
          placeholderTxt="根据姓名、昵称进行搜索"
          v-model="queryInfo.name"
          @on-search="search"
          @on-clear="search"
          @on-enter="search"
        ></MySearchInput>
      </div>

      <el-table
        class="ly_table"
        :data="projectTable"
        v-loading="loading"
        :header-cell-style="{ background: '#F5F6F7', color: '#363E4D' }"
        @selection-change="handleSelectionChange"
        :default-sort="{ prop: 'date', order: 'descending' }"
        @sort-change="sortChange"
      >
        <el-table-column type="selection" width="55" align="center" />

        <template slot="empty">
          <img src="@/assets/img/table.png" alt="没有数据" srcset="" />
        </template>

        <!-- 编号列 -->
        <el-table-column label="编号" align="center" width="100" prop="id">
        </el-table-column>

        <!-- 数据完整度列 -->
        <el-table-column label="数据完整度" align="center" width="90">
          <template #default="{ row }">
            <el-progress
              type="circle"
              width="50"
              :percentage="row.dataIntegrity"
              :color="customColorMethod(row.dataIntegrity)"
            ></el-progress>
          </template>
        </el-table-column>

        <!-- 数据质量列（带进度条效果） -->
        <el-table-column label="数据质量" align="center" width="80">
          <template #default="{ row }"> {{ row.dataQuality }}</template>
        </el-table-column>

        <!-- 姓名列 -->
        <el-table-column label="姓名" align="center" width="90" prop="name">
        </el-table-column>

        <!-- 昵称列 -->
        <el-table-column label="昵称" align="center" width="90" prop="nickname">
        </el-table-column>

        <!-- 描述列 -->
        <el-table-column
          label="描述"
          align="center"
          prop="description"
          show-overflow-tooltip
        >
        </el-table-column>

        <!-- 价值描述列 -->
        <el-table-column
          label="价值描述"
          align="center"
          width="150"
          prop="valueDescription"
          show-overflow-tooltip
        >
        </el-table-column>

        <!-- 上级超级个体编号 -->
        <el-table-column
          label="上级超级个体编号"
          align="center"
          width="180"
          prop="superiorId"
        >
        </el-table-column>

        <!-- 上级超级个体名称 -->
        <el-table-column
          label="上级超级个体名称"
          align="center"
          width="150"
          prop="superiorName"
        >
        </el-table-column>

        <!-- 创建日期列 -->
        <el-table-column
          label="创建日期"
          align="center"
          width="120"
          prop="createDate"
        >
        </el-table-column>

        <el-table-column label="操作" width="140" align="center">
          <template v-slot="{ row }">
            <div class="flex_top">
              <button-table
                @buttonClick="editItem(row)"
                content="编辑"
                icon="jr-iconjr-icon-edit"
              />
              <button-table
                @buttonClick="deleteItem(row)"
                content="删除"
                icon="jr-iconjr-icon-delect"
              />
            </div>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        :current-page="queryInfo.pageNum"
        :page-sizes="[10, 30, 50, 100, 200]"
        :page-size="queryInfo.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </div>
  </div>
</template>
<script>
import SelectTreeRadio from "@/components/SelectTreeRadio.vue";
import ImportFilePopup from "@/components/ImportFilePopup/index.vue";
import ButtonTable from "@/components/ButtonTable.vue";

export default {
  components: {
    SelectTreeRadio,
    ImportFilePopup,
    ButtonTable
  },
  data() {
    return {
      loading: false,
      total: 2,
      queryInfo: {
        pageSize: 10,
        pageNum: 1,
        industryCategory: "",
        name: "",
        columnName: "create_time",
        order: 1, // 0正序 1倒叙
      },
      projectTable: [
        {
          id: "CTQY39409",
          dataIntegrity: 97,
          dataQuality: 95,
          name: "张立群",
          nickname: "AI绘画导师",
          description:
            "湖南金龙智造科技股份有限公司是一家拥有设计、研发、制造...",
          valueDescription: "个体价值是自我实现与社会贡献的动态统一体",
          superiorId: "2854159632145632223",
          superiorName: "AI绘画导师王五",
          createDate: "2021年12月1日",
          companyCode:"CTQY-969558551"
        },
        {
          id: "CTQY39410",
          dataIntegrity: 95,
          dataQuality: 90,
          name: "张立群",
          nickname: "AI绘画导师",
          description:
            "湖南金龙智造科技股份有限公司是一家拥有设计、研发、制造...",
          valueDescription: "个体价值是自我实现与社会贡献的动态统一体",
          superiorId: "2854159632145632223",
          superiorName: "AI绘画导师王五",
          createDate: "2021年12月1日",
          companyCode:"CTQY-969558551"
        },
      ],
      customColors: [
        { color: "#1E9FFF", percentage: 20 },
        { color: "#1E9FFF", percentage: 40 },
        { color: "#1E9FFF", percentage: 60 },
        { color: "#1E9FFF", percentage: 80 },
        { color: "#1E9FFF", percentage: 100 },
      ],
    };
  },
  methods: {
    customColorMethod(percentage) {
      return (
        this.customColors.find((color) => percentage <= color.percentage)
          ?.color || "#1E9FFF"
      );
    },
    multiDelete(e) {},
    search() {},
    popoverClick() {},
    uploadTime() {},
    handleSelectionChange() {},
    sortChange() {},
    handleSizeChange() {},
    handleCurrentChange() {},
    editItem(row) {
      this.$router.push({
        path: "/superIndividual/detail",
        query: {
          id: row.id,
          companyCode:row.companyCode,
          enterpriseType: 1,
        },
      });
    },
    deleteItem() {},
  },
};
</script>

<style lang="less" scoped>
.projectData {
  /deep/ .el-input-group__append {
    background: #1e9fff;
    color: #fff;
    border: 1px solid #1e9fff;
  }
  .caretTime:hover {
    cursor: pointer;
  }
  .flex_top {
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .color1 {
    color: #34c759;
  }
}
.isActiveTime1 {
  color: #1e9fff !important;
}
.iconColor {
  color: #c0c4cc !important;
}
/deep/ .filterInfo .el-form-item__content {
  padding: 0;
}
</style>